export const AFFILIATE_PROGRAM = {
  name: "ChickyTutor Affiliate Program",
  commissionPercent: 15,
  commissionBase: "net collected subscription revenue",
  commissionDurationMonths: 12,
  attributionWindowDays: 30,
  payoutCadence: "monthly",
  payoutThresholdEur: 50,
  validationPeriodDays: 30,
  contactEmail: "feedback@chickytutor.com",
  termsEffectiveDate: "13 August 2026",
} as const;
